<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-select
                filterable
                clearable
                class="ele-block"
                v-model="where.user_id"
                placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>成功条数(收): {{ summary.in_count }}</span>
        <span>金额(收): {{ summary.in_amount }}</span>
        <span>成功条数(付): {{ summary.out_count }}</span>
        <span>金额(付): {{ summary.out_amount }}</span>
        <span>盈利: {{ summary.yingli }}</span>
        <span>增加金额: {{ summary.adjust_money }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="loadData"
        :columns="columns"
        :need-page="false"
        :toolkit="[]"
        height="calc(100vh - 360px)" />
    </el-card>
  </div>
</template>

<script>
import reconTime from '@/mixins/recon-time';

const EMPTY_SUMMARY = {
  in_count: 0,
  in_amount: '0.00',
  out_count: 0,
  out_amount: '0.00',
  yingli: '0.00',
  adjust_money: '0.00'
};

function moneyColumn(prop, label, minWidth = 110) {
  return {
    prop,
    label,
    minWidth,
    align: 'right',
    showOverflowTooltip: true,
    formatter: (_row, _column, cellValue) => {
      if (cellValue === '-' || cellValue === '' || cellValue == null) return '-';
      const num = Number(cellValue);
      return Number.isFinite(num) ? num.toFixed(2) : cellValue;
    }
  };
}

export default {
  name: 'UserBills',
  mixins: [reconTime],
  data() {
    return {
      columns: [
        { prop: 'name', label: '货币类型', minWidth: 100, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'in_count', label: '成功条数(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        moneyColumn('in_rate', '手续费(收)'),
        moneyColumn('in_paymentAmount', '金额(收)'),
        moneyColumn('in_fees', '费率(收)'),
        moneyColumn('sj_payin', '入账(收)'),
        { prop: 'out_count', label: '成功条数(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        moneyColumn('out_rate', '手续费(付)'),
        moneyColumn('out_paymentAmount', '金额(付)'),
        moneyColumn('out_fees', '费率(付)'),
        moneyColumn('yingli', '盈利', 100)
      ],
      where: { user_id: undefined, time: null },
      userList: [],
      summary: { ...EMPTY_SUMMARY }
    };
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    loadData(params, callback) {
      const where = (params && params.where) || this.where || {};
      this.$http
        .get('/Reconciliation/bussiness', {
          params: {
            user_id: where.user_id || undefined,
            time: where.time || undefined
          }
        })
        .then((res) => {
          if (res.data.code !== 0) {
            this.summary = { ...EMPTY_SUMMARY };
            this.$message.error(res.data.msg);
            callback([]);
            return;
          }
          this.summary = { ...EMPTY_SUMMARY, ...(res.data.summary || { adjust_money: res.data.adjust_money || '0.00' }) };
          callback(Array.isArray(res.data.data) ? res.data.data : []);
        })
        .catch((e) => {
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(e.message);
          callback([]);
        });
    },
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = { user_id: undefined, time: null };
      this.applyTimeQuick('today', true);
    },
    getUserList() {
      this.$http
        .get('/User/getUserList')
        .then((res) => {
          if (res.data.code === 0) {
            this.userList = (res.data.data || []).map((item) => ({
              id: item.id,
              username: item.username
            }));
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
